import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  CartesianGrid,
  LabelList,
} from "recharts";
import { amountFormat } from "../../utils";

const renderCustomizedLabel = (props) => {
  const { index, x, y, value, data, roi = 8, firstPositiveIndex } = props;

  // Show first and last valid data points
  if (index === firstPositiveIndex || index === data?.length - 1) {
    return (
      <>
        <text
          x={x}
          y={y - 20}
          fill="#4287f5"
          textAnchor="middle"
          fontSize="11"
          fontWeight="bold"
        >
          ₹{amountFormat(value)}
        </text>
        {index === firstPositiveIndex && (
          <text
            x={x}
            y={y - 10}
            fill="#888"
            textAnchor="middle"
            fontSize="10"
            fontWeight="bold"
          >
            Current Fund Value
          </text>
        )}
        {index === data?.length - 1 && (
          <text
            x={x}
            y={y - 5}
            fill="#888"
            textAnchor="middle"
            fontSize="10"
            fontWeight="bold"
          >
            Growth @{roi}%
          </text>
        )}
      </>
    );
  }
  return null;
};

const renderCustomizedLabel2 = (props) => {
  const { index, x, y, value } = props;

  // Show only first and last points
  if (index ===4 && value) {
    return (
      <>
        <text
          x={x}
          y={y + 15}
          fill="#4287f5"
          textAnchor="middle"
          fontSize="11"
          fontWeight="bold"
        >
          ₹{amountFormat(value)}
        </text>
       
          <text
            x={x}
            y={y + 25} // Adjust spacing below the number
            fill="#888"
            textAnchor="middle"
            fontSize="10"
            fontWeight="bold"
          >
            If you don't pay
          </text>
      
      </>
    );
  }
  return null;
};

const EnforcedLineChart = ({ data, roi }) => {
  const modifiedData = data.map((item, index) => ({
    ...item,
    endYearFundValueDiscontinued:
      index <= 4 ? item.endYearFundValueDiscontinued : null,
  }));
  const firstPositiveIndex = data.findIndex(
    (d) => d.endYearFundValue && d.endYearFundValue > 0
  );

  return (
    <div className="">
      <ResponsiveContainer width={"95%"} height={340}>
        <LineChart
          data={modifiedData}
          margin={{
            top: 40,
            right: 40,
            left: 40,
            bottom: 5,
          }}
        >
          <XAxis dataKey="policyYear" />
          <YAxis />
          <CartesianGrid strokeDasharray="3 3" />
          <Tooltip />
          <Legend />
          <Line
            name="8% Fixed"
            type="monotone"
            dataKey="endYearFundValueFixed"
            // stroke="#ADDFFF"
            stroke="#2d7ee0"
            strokeWidth={2}
          >
            <LabelList
              roi={8}
              data={data}
              
              content={(props) => renderCustomizedLabel({ ...props, data,firstPositiveIndex })}
            />
          </Line>
          <Line
            name={`${roi}%`}
            type="monotone"
            dataKey="endYearFundValue"
            // stroke="#000080"
            stroke="#5cc4e0"
            strokeWidth={2}
          >
            <LabelList
              roi={roi}
              data={data}
              content={(props) =>
                renderCustomizedLabel({ ...props, data, roi,firstPositiveIndex })
              }
              firstPositiveIndex
            />
          </Line>
          <Line
            name="Discontinued"
            type="monotone"
            dataKey="endYearFundValueDiscontinued"
            stroke="#000080"
            strokeWidth={2}
          >
            {" "}
            <LabelList
          
              content={(props) =>
                renderCustomizedLabel2({ ...props })
              }
            />
          </Line>
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default EnforcedLineChart;
